export const locationCookieName = 'nb-loc';
export const locationCookieMaxAge = 60 * 60 * 24;
export const cloudFrontCountryHeaderName = 'CloudFront-Viewer-Country';
export const cloudFlareCountryHeaderName = 'cf-ipcountry';
